<template>
  <div>
    <!--    搜索部分-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="资讯标题">
        <el-input v-model="enquiryForm.title" placeholder="请输入资讯标题" size="medium" clearable></el-input>
      </el-form-item>
      <el-form-item label="主分类">
        <el-select v-model="enquiryForm.type_from" :disabled="disableMainOpts" placeholder="请选择" filterable clearable
                   @change="mainOptChange()">
          <el-option
              v-for="item in type_from_options"
              :key="item.id"
              :label="item.type_name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子分类">
        <el-select v-model="enquiryForm.type_son_from" :disabled="disableSubOpts" placeholder="请选择" filterable
                   clearable>
          <el-option
              v-for="item in type_son_from_opts"
              :key="item.id"
              :label="item.title"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div style=";margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="success" style="font-size: 12px;" icon="el-icon-edit" @click="add()">发布资讯</el-button>
    </div>

    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">
      <!-- 'ID', '分类', '子分类', '标题', '可见范围', '类型', '操作' -->
      <el-table-column prop="id" label="ID" header-align="center" align="center" sortable></el-table-column>
      <el-table-column prop="cate_main_data" label="分类" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.cate_main_data.type_name }}
        </template>
      </el-table-column>
      <el-table-column prop="cate_sub_data" label="子分类" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.cate_sub_data.title }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" header-align="center" align="center"></el-table-column>
      <el-table-column prop="look_type" label="可见范围" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.look_type.text }}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.type.text }}
        </template>
      </el-table-column>
      <el-table-column prop="opt" label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <el-link @click="handleEdit(scope.$index, scope.row)"
                   type="primary" :underline="false" style="padding-right: 10px;">编辑
          </el-link>
          <el-link @click="handleDel(scope.$index, scope.row)" type="danger" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
                   layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
  </div>
</template>

<script>
export default {
  name: "articleManagement",
  data() {
    return {
      loading: false,
      total: 0, //总数
      page_size: 20, //条数
      tableData: [], //表格数据
      disableMainOpts: true,//是否禁用主分类
      disableSubOpts: true,//是否禁用子分类
      type_from_options: [],//主分类
      type_son_from_opts: [],//子分类
      enquiryForm: {
        title: '',//资讯标题
        type_from: '',//主分类
        type_son_from: '',//子分类
        page: 1,
        page_size: 20
      }
    }
  },
  created() {
    this.getData(this.enquiryForm);
    this.loadMainOpts();
  },
  methods: {
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.title = "";//资讯标题
      searchForm.type_from = '';//主分类
      searchForm.type_son_from = '';//子分类
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/school/contentList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    //加载主分类数据
    loadMainOpts() {
      this.disableMainOpts = true;
      this.$api.post("/api/school/cateMain", {}, res => {
        if (res.status == 200) {
          let opts = res.data;
          this.type_from_options = opts; //主分类
        } else {
          this.$message.error(res.msg);
        }
        this.disableMainOpts = false;//解除禁用
      });
    },
    //主分类改变时，联动加载子分类
    mainOptChange() {
      this.loadSubOpts(this.enquiryForm.type_from);
    },
    //加载子分类数据
    loadSubOpts(mainId) {
      this.disableSubOpts = true;
      let params = {id: mainId};
      this.$api.post("/api/school/cateSub", params, res => {
        if (res.status == 200) {
          let opts = res.data;
          this.type_son_from_opts = opts; //主分类
        } else {
          this.$message.error(res.msg);
        }
        this.disableSubOpts = false;//解除禁用
      });
    },
    //发布资讯
    add() {
      this.$router.push({
        path: '/articleDetails',
        query: {id: null},
      })
    },
    //编辑
    handleEdit(index, row) {
      this.$router.push({
        path: '/articleDetails',
        query: {id: row.id},
      })
    },
    //删除
    handleDel(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let params = {id: row.id};
        this.delData(params);// 删除数据
      }).catch(() => {
        // 点击取消
      });
    },
    delData(params) {
      this.$api.post("/api/school/contentDelete", params, res => {
        if (res.status == 200) {
          this.$message.success('删除成功!');
          this.handleSearch(this.enquiryForm);//刷新列表
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>